import { FC } from 'react';
import { ContactPhone } from './ContactPhone/ContactPhone';

export const ContactPhonePage: FC = () => {
  return <ContactPhone />;
};
